import React, { useState, useEffect } from "react";
import "./profile.scss";
import ProfileImage from "../../assets/images/UserDefault.jpeg";
import { ApiGet, ApiPut } from "../../../src/Helpers/Api/ApiData";
import * as userUtil from "../../utils/user.util";
import { toast } from "react-toastify";
export default function Profile() {
  const [UserData, setUserData] = useState({});
  const [profileImagePreview, setProfileImagePreview] = useState();
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);

  const userInfo = userUtil.getUserInfo();

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    let userInfo = userUtil.getUserInfo();
    // setLoading(true);
    await ApiGet(`admin/get-admin/${userInfo?._id}`)
      .then((res) => {
        // setLoading(false);
        console.log("get user", res?.data?.payload?.admin);
        setUserData(res?.data?.payload?.admin);
        setProfileImagePreview(res?.data?.payload?.admin?.photo);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const validationForm = () => {
    let errors = {};
    let formValied = true;
    if (!UserData.fname) {
      formValied = false;
      errors["fname"] = "Bitte geben Sie Ihre ein Vorname.";
    }
    if (!UserData.lname) {
      formValied = false;
      errors["lname"] = "Bitte geben Sie Ihre ein Nachname.";
    }
    if (!UserData.phone) {
      formValied = false;
      errors["phone"] = "Bitte geben Sie Ihre ein Telefonnummer.";
    }
    setErrors(errors);
    return formValied;
  };
  
  const handleAddProfileDetails = (e) => {
    const { name, value } = e.target;
    setUserData({ ...UserData, [name]: value });
    if (name === "phone") {
      let val = e.target.value.replace(/\D/g, "");
      setUserData({ ...UserData, [name]: val });
    }
    if (name === "photo") {
      // setUserData({ ...UserData, [name]: e.target.files[0] });
      setProfileImagePreview(URL.createObjectURL(e.target.files[0]));
    }
  };
  console.log("userrrrrrrrr", UserData);


  const updateUser = async (e) => {
    if (validationForm()) {
      setLoader(true);
      let ProPic = new FormData();
      ProPic.append("photo", profileImagePreview);

      await ApiPut(`admin/updatePhoto/${userInfo?._id}`, ProPic) //api for update profile pic
        .then((res) => {
          console.log("update pic res", res);
          if (res?.data?.result === 0) {
            getUsers();
            setLoader(false);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      await ApiPut(`admin/updateAdmin/${userInfo?._id}`, UserData)
        .then((res) => {
          if (res?.data?.result === 0) {
            toast.success("Profil erfolgreich aktualisiert");
            setLoader(false);
            getUsers();
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
          toast.error(err);
        });
    }
  };
  return (
    <>
      <div>
        <div className="profile-page-section-alignment">
          <div className="grid">
            <div className="grid-items">
              <div className="profile-image-alignment">
                <div>
                  <img
                    src={
                      profileImagePreview !== undefined
                        ? !profileImagePreview?.toString()?.includes(".com")
                          ? URL.createObjectURL(profileImagePreview)
                          : profileImagePreview
                        : ProfileImage
                    }
                  />
                </div>
                <div>
                  <label variant="outlined" htmlFor="photo">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 10.5C19.7348 10.5 19.4804 10.6054 19.2929 10.7929C19.1054 10.9804 19 11.2348 19 11.5V18.5C19 18.7652 18.8946 19.0196 18.7071 19.2071C18.5196 19.3946 18.2652 19.5 18 19.5H4C3.73478 19.5 3.48043 19.3946 3.29289 19.2071C3.10536 19.0196 3 18.7652 3 18.5V10.5C3 10.2348 3.10536 9.98043 3.29289 9.79289C3.48043 9.60536 3.73478 9.5 4 9.5H6C6.21807 9.51138 6.43386 9.45107 6.61443 9.32829C6.795 9.2055 6.93042 9.02698 7 8.82L7.54 7.18C7.60709 6.98138 7.7349 6.80887 7.90537 6.68684C8.07584 6.56482 8.28036 6.49946 8.49 6.5H14C14.2652 6.5 14.5196 6.39464 14.7071 6.20711C14.8946 6.01957 15 5.76522 15 5.5C15 5.23478 14.8946 4.98043 14.7071 4.79289C14.5196 4.60536 14.2652 4.5 14 4.5H8.44C7.81155 4.50118 7.19933 4.69968 6.68977 5.06751C6.1802 5.43533 5.79901 5.95389 5.6 6.55L5.28 7.55H4C3.20435 7.55 2.44129 7.86607 1.87868 8.42868C1.31607 8.99129 1 9.75435 1 10.55V18.55C1 19.3456 1.31607 20.1087 1.87868 20.6713C2.44129 21.2339 3.20435 21.55 4 21.55H18C18.7956 21.55 19.5587 21.2339 20.1213 20.6713C20.6839 20.1087 21 19.3456 21 18.55V11.55C21.0068 11.4145 20.9859 11.2791 20.9387 11.1519C20.8915 11.0248 20.8189 10.9086 20.7254 10.8103C20.6318 10.7121 20.5193 10.634 20.3946 10.5806C20.2699 10.5273 20.1356 10.4998 20 10.5ZM11 9.5C10.2089 9.5 9.43552 9.7346 8.77772 10.1741C8.11992 10.6136 7.60723 11.2384 7.30448 11.9693C7.00173 12.7002 6.92252 13.5044 7.07686 14.2804C7.2312 15.0563 7.61216 15.769 8.17157 16.3284C8.73098 16.8878 9.44372 17.2688 10.2196 17.4231C10.9956 17.5775 11.7998 17.4983 12.5307 17.1955C13.2616 16.8928 13.8864 16.3801 14.3259 15.7223C14.7654 15.0645 15 14.2911 15 13.5C15 12.4391 14.5786 11.4217 13.8284 10.6716C13.0783 9.92143 12.0609 9.5 11 9.5ZM11 15.5C10.6044 15.5 10.2178 15.3827 9.88886 15.1629C9.55996 14.9432 9.30362 14.6308 9.15224 14.2654C9.00087 13.8999 8.96126 13.4978 9.03843 13.1098C9.1156 12.7219 9.30608 12.3655 9.58579 12.0858C9.86549 11.8061 10.2219 11.6156 10.6098 11.5384C10.9978 11.4613 11.3999 11.5009 11.7654 11.6522C12.1308 11.8036 12.4432 12.06 12.6629 12.3889C12.8827 12.7178 13 13.1044 13 13.5C13 14.0304 12.7893 14.5391 12.4142 14.9142C12.0391 15.2893 11.5304 15.5 11 15.5ZM22 4.5H21V3.5C21 3.23478 20.8946 2.98043 20.7071 2.79289C20.5196 2.60536 20.2652 2.5 20 2.5C19.7348 2.5 19.4804 2.60536 19.2929 2.79289C19.1054 2.98043 19 3.23478 19 3.5V4.5H18C17.7348 4.5 17.4804 4.60536 17.2929 4.79289C17.1054 4.98043 17 5.23478 17 5.5C17 5.76522 17.1054 6.01957 17.2929 6.20711C17.4804 6.39464 17.7348 6.5 18 6.5H19V7.5C19 7.76522 19.1054 8.01957 19.2929 8.20711C19.4804 8.39464 19.7348 8.5 20 8.5C20.2652 8.5 20.5196 8.39464 20.7071 8.20711C20.8946 8.01957 21 7.76522 21 7.5V6.5H22C22.2652 6.5 22.5196 6.39464 22.7071 6.20711C22.8946 6.01957 23 5.76522 23 5.5C23 5.23478 22.8946 4.98043 22.7071 4.79289C22.5196 4.60536 22.2652 4.5 22 4.5Z"
                        fill="#F6F6F6"
                      />
                    </svg>
                  </label>
                  <input
                    type="file"
                    name="photo"
                    accept="image/*"
                    id="photo"
                    className="hide"
                    onChange={(e) => {
                      console.log("onchange img", e.target.files[0]);
                      setProfileImagePreview(e.target.files[0]);
                    }}
                  />
                </div>
              </div>
              <div className="input">
                <label> Vorname</label>
                <input
                  type="text"
                  name="fname"
                  value={UserData?.fname}
                  onChange={(e) => handleAddProfileDetails(e)}
                />
                <span
                  style={{
                    color: "red",
                    fontSize: "18px",
                  }}
                >
                  {errors["fname"]}
                </span>
              </div>
              <div className="input">
                <label>Nachname</label>
                <input
                  type="text"
                  name="lname"
                  value={UserData?.lname}
                  onChange={(e) => handleAddProfileDetails(e)}
                />
                <span
                  style={{
                    color: "red",
                    fontSize: "18px",
                  }}
                >
                  {errors["lname"]}
                </span>
              </div>
              <div className="input">
                <label>Telefonnummer</label>
                <input
                  type="phone"
                  name="phone"
                  value={UserData?.phone}
                  maxLength="10"
                  onChange={(e) => handleAddProfileDetails(e)}
                />
                <span
                  style={{
                    color: "red",
                    fontSize: "18px",
                  }}
                >
                  {errors["phone"]}
                </span>
              </div>
              <div className="input">
                <label> E-Mail</label>
                <input
                  type="text"
                  value={UserData?.email}
                  onChange={(e) => handleAddProfileDetails(e)}
                  disabled
                />
              </div>
              <div className="input">
                <button onClick={(e) => updateUser(e)} className="update-btn">
                  {loader ? (
                    <>
                      <div>Speichern...</div>
                    </>
                  ) : (
                    <>
                      <div>Speichern</div>
                    </>
                  )}
                </button>
              </div>
            </div>

            <div className="grid-items"></div>
          </div>
        </div>
      </div>
    </>
  );
}
